import { createUseStyles } from 'react-jss';

export default createUseStyles({
  btnGroup: {
    width: '88px',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },

  scrollerWrapper: {
    maxHeight: 'calc(100vh - 200px)',
    overflowY: 'auto',
    paddingRight: '4px',
  },

  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    fontSize: '16px',
    height: '64px',
    '&:hover': {
      boxShadow: '4px 4px 4px 4px rgba(16, 33, 49, 0.04)',
    },
  },

  itemWithBadges: {
    justifyContent: 'initial',
  },

  badge: {
    marginLeft: '10px',
    backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
  },

  inputsGrid: {
    display: 'grid',
    gridTemplateRows: '100px 1fr',
  },
});
